import {Focusable} from './focusable.interface';

export class ResultWithHighlight implements Focusable{
  id: string;

  item: any;

  highlights: string[] = [];

  altHighlighted = false;

  focused = false;

  constructor(attr: { item, highlights? , altHighlighted?}) {
    this.item = attr.item;
    this.altHighlighted = attr.altHighlighted;
    if (attr.highlights && attr.highlights.length > 0) {
      attr.highlights.forEach(highlight => this.highlights.push(highlight));
    }
    if (this.item['type'].includes("_descriptor")) {
      this.id = this.item['nlpId'];
    } else {
      this.id = this.item['id'];
    }
  }

  getJoined(limitNestedIteration: number) {
    return this.highlights.slice(0, limitNestedIteration).join(', ');
  }

  clearFocus() {
    this.focused = false;
  }

  focus() {
    this.focused = true;
  }
}
